export const credentials_en = {
  sesLoading: "Loading domain status…",
  sesEmptyTitle: "No sending domain yet",
  sesEmptyDesc:
    "Add a domain in Edit to send from your own brand and land in more inboxes.",
  sesAuthTitle: "Authenticate your sending domain",
  sesAuthDesc:
    "Add these records at your DNS provider (Cloudflare, GoDaddy, and the like). This confirms you own {domain} and keeps your email out of spam.",
  sesDnsRecords: "DNS records",
  sesColType: "Type",
  sesColName: "Name",
  sesColValue: "Value",
  sesCopyAll: "Copy all",
  sesVerifyDomain: "Verify domain",
  sesVerifyNote:
    "DNS changes can take a few minutes to appear — you can leave and come back.",
  sesStatusVerified: "Verified",
  sesStatusPending: "Pending",
  sesVerifiedMsg: "{domain} is verified and ready to send.",
  sesDomainVerified: "Domain verified — you're ready to send.",
  sesDomainNotYet:
    "Not verified yet — the records aren't visible in DNS. Give it a few minutes and try again.",
  sesVerifyFailed: "Couldn't check verification. Please try again.",
  sesCopied: "Copied to clipboard.",
  sesCopiedAll: "All records copied.",
  sendingDomainSelectPlaceholder: "Select a verified sending domain",
  sendingDomainNoneVerified: "No verified domains yet — add one below",
  sendingDomainStatus_verified: "Verified",
  sendingDomainStatus_pending: "Pending",
  sendingDomainStatus_failed: "Failed",
  sendingDomainViewRecords: "View DNS records",
  sendingDomainDnsHint:
    "Add these CNAME records to your DNS, then click Verify:",
  sendingDomainCopy: "Copy",
  sendingDomainVerify: "Verify",
  sendingDomainAddPlaceholder: "yourdomain.com",
  sendingDomainAdd: "Add domain",
  sendingDomainAddFailed: "Could not add domain",
  sendingDomainVerified: "Domain verified",
  sendingDomainNotYet: "Not verified yet — DNS may still be propagating",
  sendingDomainVerifyFailed: "Verification check failed",
  sendingDomainCopied: "Copied",
  sequence_credentials_aside_create_new: "Create a credential",
  sequence_credentials_setting_title: "Credential settings",
  save_changes: "Save changes",
  sequence_credential_create_dialog_title: "Set Up New Credentials",
  sequence_credentials_create_dialog_empty:
    "Let’s get you connected—choose an account type and integration method above",
  sequence_credential_create_dialog_bottom_info:
    "Please authenticate before saving.",
  authenticate: "Authenticate",
  sequence_credential_create_dialog_common_name_label: "Credential Name",
  sequence_credential_create_dialog_common_channel_type_label: "Channel type",
  sequence_credential_create_dialog_common_authentication_type_label:
    "Integration method",
  sequence_credential_main_empty_title: "Connect Your Account to Get Started",
  sequence_credential_main_empty_description:
    "To start automating your outreach, link an account. This allows us to send messages, manage connections, and perform actions on your behalf.",
  sequence_credential_main_empty_button: "Link account",
  sequence_credentail_aside_empty_description: "Nothing here yet",
  sequence_credential_authentication_title: "Authentication",
  sequence_credential_authentication_description:
    "This account is linked for sending messages and actions. You can edit, reauthorize, or remove it anytime.",
  sequence_credentials_masked: "Credentials are masked",
  credential_empty_title: "All set!",
  credential_empty_desc:
    "This credential type is preconfigured. You’ll only need to update it if your access token changes",
  sequence_credential_inactive: "Inactive",
};

export const credentials_zh_tw = {
  sequence_credentials_aside_create_new: "建立憑證",
  sequence_credentials_setting_title: "憑證設定",
  save_changes: "儲存變更",
  sequence_credential_create_dialog_title: "設定新憑證",
  sequence_credentials_create_dialog_empty:
    "讓我們來建立連線—請在上方選擇帳戶類型與整合方式",
  sequence_credential_create_dialog_bottom_info: "請先完成驗證後再儲存。",
  authenticate: "驗證",
  sequence_credential_create_dialog_common_name_label: "憑證名稱",
  sequence_credential_create_dialog_common_channel_type_label: "通道類型",
  sequence_credential_create_dialog_common_authentication_type_label:
    "整合方式",
  sequence_credential_main_empty_title: "連接帳戶以開始使用",
  sequence_credential_main_empty_description:
    "若要開始自動化拓展流程，請連結帳戶。這將允許我們代表您傳送訊息、管理連結並執行操作。",
  sequence_credential_main_empty_button: "連結帳戶",
  sequence_credentail_aside_empty_description: "這裡還沒有內容",
  sequence_credential_authentication_title: "驗證資訊",
  sequence_credential_authentication_description:
    "此帳戶已連結以執行訊息傳送與操作。您可以隨時編輯、重新授權或移除。",
  sequence_credentials_masked: "憑證已隱藏",
  credential_empty_title: "一切準備就緒！",
  credential_empty_desc: "此憑證類型已預先設定，僅在存取權杖變更時需要更新。",

  sequence_credential_inactive: "失效",
};
export const credentials_zh_cn = {
  sequence_credentials_aside_create_new: "创建凭证",
  sequence_credentials_setting_title: "凭证设置",
  save_changes: "保存更改",
  sequence_credential_create_dialog_title: "设置新凭证",
  sequence_credentials_create_dialog_empty:
    "让我们开始连接——请在上方选择账户类型和集成方式",
  sequence_credential_create_dialog_bottom_info: "请先完成身份验证再保存。",
  authenticate: "验证",
  sequence_credential_create_dialog_common_name_label: "凭证名称",
  sequence_credential_create_dialog_common_channel_type_label: "渠道类型",
  sequence_credential_create_dialog_common_authentication_type_label:
    "集成方式",
  sequence_credential_main_empty_title: "连接您的账户以开始使用",
  sequence_credential_main_empty_description:
    "要开始自动化您的外联流程，请先连接一个账户。这将允许我们代表您发送消息、管理联系人并执行操作。",
  sequence_credential_main_empty_button: "连接账户",
  sequence_credentail_aside_empty_description: "这里还没有内容",
  sequence_credential_authentication_title: "身份验证",
  sequence_credential_authentication_description:
    "该账户已连接，可用于发送消息和执行操作。您可以随时编辑、重新授权或移除。",
  sequence_credentials_masked: "凭证已隐藏",
  credential_empty_title: "一切就绪！",
  credential_empty_desc: "此凭证类型已预配置，仅在访问令牌更改时需要更新。",

  sequence_credential_inactive: "失效",
};

export const credentialsJapanese = {
  sequence_credentials_aside_create_new: "認証情報を作成",
  sequence_credentials_setting_title: "認証情報設定",
  save_changes: "変更を保存",
  sequence_credential_create_dialog_title: "新しい認証情報を設定",
  sequence_credentials_create_dialog_empty:
    "接続を確立しましょう—上記でアカウントタイプと統合方法を選択してください",
  sequence_credential_create_dialog_bottom_info: "保存前に認証を完了してください。",
  authenticate: "認証",
  sequence_credential_create_dialog_common_name_label: "認証情報名",
  sequence_credential_create_dialog_common_channel_type_label: "チャネルタイプ",
  sequence_credential_create_dialog_common_authentication_type_label:
    "統合方法",
  sequence_credential_main_empty_title: "アカウントを接続して開始",
  sequence_credential_main_empty_description:
    "自動化プロセスを開始するには、アカウントをリンクしてください。これにより、メッセージ送信、リンク管理、操作実行が可能になります。",
  sequence_credential_main_empty_button: "アカウントをリンク",
  sequence_credentail_aside_empty_description: "ここにはまだ何もありません",
  sequence_credential_authentication_title: "認証情報",
  sequence_credential_authentication_description:
    "このアカウントはメッセージ送信と操作実行のために接続されています。編集、再認証、削除はいつでも可能です。",
  sequence_credentials_masked: "認証情報はマスクされています",
  credential_empty_title: "準備が完了しました！",
  credential_empty_desc: "この認証情報タイプは事前設定済みで、アクセストークン変更時のみ更新が必要です。",

  sequence_credential_inactive: "無効"
};

export const credentialsKorean = {
  sequence_credentials_aside_create_new: "인증 정보 생성",
  sequence_credentials_setting_title: "인증 정보 설정",
  save_changes: "변경 사항 저장",
  sequence_credential_create_dialog_title: "새 인증 정보 설정",
  sequence_credentials_create_dialog_empty:
    "연결을 생성해 보세요—위에서 계정 유형과 통합 방식을 선택하세요",
  sequence_credential_create_dialog_bottom_info: "저장 전 인증을 완료해 주세요.",
  authenticate: "인증",
  sequence_credential_create_dialog_common_name_label: "인증 정보 이름",
  sequence_credential_create_dialog_common_channel_type_label: "채널 유형",
  sequence_credential_create_dialog_common_authentication_type_label:
    "통합 방식",
  sequence_credential_main_empty_title: "계정 연결하여 시작하기",
  sequence_credential_main_empty_description:
    "자동화 프로세스를 시작하려면 계정을 연결하세요. 이를 통해 메시지 전송, 링크 관리 및 작업 실행이 가능해집니다.",
  sequence_credential_main_empty_button: "계정 연결",
  sequence_credentail_aside_empty_description: "여기에 아직 내용이 없습니다",
  sequence_credential_authentication_title: "인증 정보",
  sequence_credential_authentication_description:
    "이 계정은 메시지 전송과 작업 실행을 위해 연결되었습니다. 언제든지 편집, 재인증 또는 제거할 수 있습니다.",
  sequence_credentials_masked: "인증 정보가 마스킹됨",
  credential_empty_title: "모든 준비가 완료되었습니다!",
  credential_empty_desc: "이 인증 정보 유형은 사전 설정되어 있으며 액세스 토큰 변경 시에만 업데이트가 필요합니다.",

  sequence_credential_inactive: "비활성화"
};

export const credentialsHindi = {
  sequence_credentials_aside_create_new: "क्रेडेंशियल बनाएं",
  sequence_credentials_setting_title: "क्रेडेंशियल सेटिंग",
  save_changes: "परिवर्तन सहेजें",
  sequence_credential_create_dialog_title: "नया क्रेडेंशियल सेट करें",
  sequence_credentials_create_dialog_empty:
    "आइए कनेक्शन बनाएं—कृपया ऊपर खाता प्रकार और एकीकरण विधि चुनें",
  sequence_credential_create_dialog_bottom_info: "सहेजने से पहले प्रमाणीकरण पूरा करें।",
  authenticate: "प्रमाणित करें",
  sequence_credential_create_dialog_common_name_label: "क्रेडेंशियल नाम",
  sequence_credential_create_dialog_common_channel_type_label: "चैनल प्रकार",
  sequence_credential_create_dialog_common_authentication_type_label:
    "एकीकरण विधि",
  sequence_credential_main_empty_title: "प्रारंभ करने के लिए खाता कनेक्ट करें",
  sequence_credential_main_empty_description:
    "ऑटोमेशन प्रक्रिया शुरू करने के लिए, कृपया एक खाता लिंक करें। यह हमें आपकी ओर से संदेश भेजने, लिंक प्रबंधित करने और क्रियाएं निष्पादित करने की अनुमति देगा।",
  sequence_credential_main_empty_button: "खाता लिंक करें",
  sequence_credentail_aside_empty_description: "यहां अभी तक कुछ नहीं है",
  sequence_credential_authentication_title: "प्रमाणीकरण जानकारी",
  sequence_credential_authentication_description:
    "यह खाता संदेश भेजने और क्रियाएं निष्पादित करने के लिए कनेक्ट किया गया है। आप कभी भी संपादित कर सकते हैं, पुनः प्रमाणित कर सकते हैं या हटा सकते हैं।",
  sequence_credentials_masked: "क्रेडेंशियल मास्क किए गए",
  credential_empty_title: "सब तैयार है!",
  credential_empty_desc: "इस क्रेडेंशियल प्रकार को पहले से कॉन्फ़िगर किया गया है और केवल एक्सेस टोकन बदलने पर अद्यतन की आवश्यकता होती है।",

  sequence_credential_inactive: "निष्क्रिय"
};